<div class="input-row">
    <table>
        <tr>
            <td>
                <div style="font-size:12px; padding-bottom:10px;"><label>Location:</label>&nbsp;<br />
                    <span style="position:relative; top:-4px;">{{inventory.LocationID}}</span>
                </div>
            </td>
            <td>
                <mat-form-field appearance="fill">
                    <mat-label>Restock To</mat-label>
                    <input #RestockLocationField [scanInput] matInput scanInput="BIN" autocomplete="off"
                        [attr.inputmode]="scanMgr.allowKeyboard ? '' : 'none'" [(ngModel)]="restockLocationIDField"
                        name="restockLocationIDField" [placeholder]="inventory.stockItem.DefaultIssueFrom || ''"
                        (scanned)="onLocationScanned($event)" [disabled]="disabled" />
                </mat-form-field>
            </td>
            <td *ngIf="suffixTemplate">
                <ng-container *ngTemplateOutlet="suffixTemplate"></ng-container>
            </td>
        </tr>
    </table>

    <button *ngIf="allowReuse" mat-raised-button matSuffix color="accent" (click)="onReusePiece.emit()">Reuse</button>
</div>